export enum ErrorBoundaryIconName {
  FlashWarning = 'FlashWarning',
}

export const errorPageInlineIconAssets: {
  [key in ErrorBoundaryIconName]: string;
} = {
  [ErrorBoundaryIconName.FlashWarning]: require('./ic-flash-warning.svg'),
};
